// extracted by mini-css-extract-plugin
export var completionBody = "_mo-2";
export var completionCard = "_mo-0";
export var completionFooter = "_mo-3";
export var completionTitle = "_mo-1";